import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useFinishDistributorTunnelMutation } from 'api/tunnelSteps';
import { userSelectors } from 'reducers';
import { texts } from 'utils/languages/fr';
import { parseFullName } from 'utils/helpers';

import TunnelStep from '../common/TunnelStep';
import TunnelBox from '../common/TunnelBox';
import { SubmitButton } from 'components';
import { Typography } from '@mui/material';

const LastStepOnboarding = () => {
    const internalUser = useSelector(userSelectors.getInternalUser);
    const [finishDistributorTunnel, { isLoading: loading, isSuccess }] =
        useFinishDistributorTunnelMutation();

    useEffect(() => {
        if (isSuccess) {
            window.location.assign('https://www.peqan.fr/');
        }
    }, [isSuccess]);

    return (
        <TunnelStep title={texts.LAST_STEP_ONBOARDING} maxWidth={950}>
            <TunnelBox>
                <Typography gutterBottom>
                    <b>{parseFullName(internalUser)}</b>
                    {` vous avez demandé l'inscription de la société ${internalUser?.distributorCompany?.corporateName} en tant que partenaire.`}
                </Typography>
                <Typography gutterBottom>{texts.LES_ELEMENTS_AURONT}</Typography>
            </TunnelBox>
            <SubmitButton
                loading={loading}
                onClick={finishDistributorTunnel}
                text={texts.TERMINER}
            />
        </TunnelStep>
    );
};

export default LastStepOnboarding;
